import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop(props: any) {
  const location = useLocation();

  useLayoutEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      const topDiv = document.getElementById("s4-workspace") as HTMLDivElement;
      if (topDiv) {
        topDiv.scrollTop = 0;
      } else {
        window.scrollTo(0, 0);
      }
    }
  }, [location]);

  return <>{props.children}</>;
}

export default ScrollToTop;
